/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserIntegrationInfoSaveRequest} from '../models/UserIntegrationInfoSaveRequest';

export interface UpdateUserIntegrationInfo$Request {
    userId: number;
    userIntegrationInfoSaveRequest: UserIntegrationInfoSaveRequest;
}

export interface UpdateUserIntegrationInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateUserIntegrationInfoRequest = createAction<PayloadData<void, UpdateUserIntegrationInfo$Request>>('UPDATE_USER_INTEGRATION_INFO__UPDATE_USER_INTEGRATION_INFO__REQUEST');
export const updateUserIntegrationInfoSuccess = createAction<PayloadData<void, UpdateUserIntegrationInfo$Request>>('UPDATE_USER_INTEGRATION_INFO__UPDATE_USER_INTEGRATION_INFO__SUCCESS');
export const updateUserIntegrationInfoFailure = createAction<PayloadData<Error, UpdateUserIntegrationInfo$Request, true>>('UPDATE_USER_INTEGRATION_INFO__UPDATE_USER_INTEGRATION_INFO__FAILURE');

export const updateUserIntegrationInfoActions = [
    updateUserIntegrationInfoRequest,
    updateUserIntegrationInfoSuccess,
    updateUserIntegrationInfoFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserIntegrationInfoSaveRequest} meta.userIntegrationInfoSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateUserIntegrationInfo = (meta: UpdateUserIntegrationInfo$Request, config?: UpdateUserIntegrationInfo$Config) => {
    return {
        CALL_API: {
            types: updateUserIntegrationInfoActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/integration-info`,
            TRANSPORT_REQUEST_BODY: meta.userIntegrationInfoSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

